import { AccountEntity } from "@goodfill/domain-entities";
import { BalanceAccountId, Amount, CorporateBondId, UserId, Currency } from "@goodfill/domain-properties";
import { CustomGetAuthDataTransaction } from "./doCustomGetUserData";

export interface UserAuthDataBalanceAccount {
  id: BalanceAccountId;
  balance: Amount;
  disponibleBalance: Amount;
  currency: Currency | null;
  bondId: CorporateBondId | null;
  transactions: CustomGetAuthDataTransaction[];
}

export class UserData {
  userId: UserId;
  account: AccountEntity;
  balanceAccounts: UserAuthDataBalanceAccount[];
  favoriteBonds: CorporateBondId[];

  constructor(
    userId: UserId,
    account: AccountEntity,
    balanceAccounts: UserAuthDataBalanceAccount[],
    favoriteBonds: CorporateBondId[],
  ) {
    this.userId = userId;
    this.account = account;
    this.balanceAccounts = balanceAccounts;
    this.favoriteBonds = favoriteBonds;
  }

  getBalanceAccount(currency: Currency): UserAuthDataBalanceAccount | null {
    const balanceAccount = this.balanceAccounts.find((balanceAccount) => balanceAccount.currency === currency);

    return balanceAccount ?? null;
  }
}
